import { Directive, HostListener, ElementRef, Input } from '@angular/core';
import Clipboard from 'clipboard/dist/clipboard.min.js';
import { AlertService } from '../../providers/alert.service';

//复制指令
//TQQ 2017-07-08
@Directive({
    selector: '[copy]'
})
export class CopyDirective {
    @Input('copy') cliptext: any;
    constructor(
        private alert: AlertService,
        private el: ElementRef
    ) {
        let clipboard = new Clipboard(el.nativeElement, {
            text: s => {
                return this.cliptext;
            }
        });
        clipboard.on('success', e => {
            this.alert.showAlert('复制成功');
            e.clearSelection();
        });
        clipboard.on('error', e => {
            console.error('Action:', e.action);
            console.error('Trigger:', e.trigger);
            this.alert.showAlert('暂不支持此浏览器，请手动复制');
        });
    }
}




// WEBPACK FOOTER //
// ./src/dires/copy/copy.diretive.ts